import React, { Component } from 'react';
import { Layout, Form, Icon, Input, Button, Checkbox, message} from 'antd';
import styles from './index.module.less';
import Signin from '@/components/Signin'
import Textbox from '@/components/Signin/Text'
import GFooter from '@/components/GlobalFooter'
import RightContent from '@/components/GlobalHeader/RightContent'

export default class SigninLayout extends Component {

  render() {
    return (
      <Layout className={styles.wrapper}>
        <Layout.Header className={styles.header}>
          <RightContent className={styles.right} routeTo='/Home' content="主页"></RightContent>
        </Layout.Header>
        <Layout.Content className={styles.content}>
          <div className={styles.bodyBox}>
            <Textbox></Textbox>
            <Signin className={styles.signinBox}></Signin>
          </div>
        </Layout.Content>
        <Layout.Footer className={styles.footer}>
            {/* 除首页外的全局Footer */}
            <GFooter></GFooter>
        </Layout.Footer>
      </Layout>
    )
    
  }
}